import { Component, OnInit, Input } from '@angular/core';
import { LifeInsuranceAddEditComponent } from './parts/add-edit/add-edit.component';

@Component({
  selector: 'app-life-insurance',
  templateUrl: './life-insurance.component.html',
  styleUrls: ['./life-insurance.component.scss']
})
export class LifeInsuranceComponent implements OnInit {

  @Input() object: Object;
  @Input() summaryOnly: boolean = false;
  public key: string;
  public extraData: Object;

  constructor() { }

  ngOnInit(): void {

    this.key = 'life-insurance-policy';
    this.extraData = {
      heading: this.object['title']['rendered'],
      component: LifeInsuranceAddEditComponent,
      showSummaryOnly: this.showSummaryOnly(),
      options: {
        class: 'modal-lg'
      },
      section: {
        key: 'life-insurance-policy',
        title: 'Life Insurance',
        type: 'children',
        childType: 'life-insurance-policy',
        plural: 'life insurance policies',
        singular: 'Life insurance Policy',
        min: 0,
        max: 0,
      },
    }

  }

  showSummaryOnly() {

    if( typeof( this.object ) === 'undefined' ) {
      return true;
    }

    return this.summaryOnly;

  }

}
